import ImageClass from "@lss/common/src/shell/Image";
import { mc } from "@lss/common/game/characters/MC";
import { extras, images, uiImages } from "@lss/common/game/story/images";
import { pcLady } from "../characters/PCLady";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { empty } from "../characters/empty";
import { ann } from "../characters/Ann";
import Game from "../../src/shell/Game";
import { ClubEventWithoutJoe } from "./V4_BarWithoutJoey";
import { ClubEventJoe } from "./V4_BarWithJoey";
import { AfterClubSexTape } from "./V4_SexTape";
import { AfterClubVanessaLeftAloneGoFast, AfterClubVanessaLeftAloneWaitAbit } from "./V4_VanessaBarAfterParty";
import { hobo } from "../characters/Hobo";
import { AfterClub2To4Home } from "./V4_AnnMCSex";
import UI from "../../src/shell/UI";
import { getInstaData } from "../helpers/InstaPostsHelpers";
import { Insta } from "../../src/components/insta/InstaClass";
import { V5Start } from "./V5";
import { Phone } from "../../src/components/phoneUI/PhoneClass";
import { joe } from "../characters/Joe";
import { vanessa } from "../characters/Vanessa";
import { alex } from "../characters/Alex";
import { doSmsSound, doTransition } from "../helpers/helpers";


export const RoomAfterEventsPassedTime = async (): Promise<any> => {
    ImageClass.setImage(images.v1.Room1, { transition: true });
    mc.talk(`Are you following so far?`, { method: "On Chat" });
    pcLady.talk(`Yes.`, { method: "Over Chat" });
    mc.talk(`Just checking. You were quiet.`, { method: "On Chat" });
    if (mc.properties.annStatus === "gf") {
        pcLady.talk(`Reading your every word, I'm happy you finally got some action with Ann!`, { method: "Over Chat" });
        if (Question.globalAnswers.v3ShovedAnnHeadForBJ) {
            pcLady.talk(`But don't you think pushing her head was too much?`, { method: "Over Chat" });
            mc.talk(`No.`, { method: "On Chat" });
            pcLady.talk(`I mean, most of the time I agree with Vanessa.`, { method: "Over Chat" });
            pcLady.talk(`I really think that she needed a dick in her life lol.`, { method: "Over Chat" });
            pcLady.talk(`But pushing her head like that?`, { method: "Over Chat" });
            mc.talk(`She got over that quickly.`, { method: "On Chat" });
            mc.talk(`She might like it.`, { method: "On Chat" });
            pcLady.talk(`Does she like it now?`, { method: "Over Chat" });
            mc.talk(`If you will let me continue you will know.`, { method: "On Chat" });
            pcLady.talk(`OMG! I was listening before you stopped to ask me if I'm still here.`, { method: "Over Chat" });
        } else {
            mc.talk(`If you call a handjob action then yeah...`, { method: "On Chat" });
            pcLady.talk(`It's something right?`, { method: "Over Chat" });
            pcLady.talk(`I would lie if I said that I don't agree with Vanessa.`, { method: "Over Chat" });
            pcLady.talk(`That girl needs a dick in her life lol.`, { method: "Over Chat" });
            pcLady.talk(`Will it happen soon???`, { method: "Over Chat" });
            mc.talk(`I'm getting there!`, { method: "On Chat" });
        }


    } else if (mc.properties.annStatus === "hate") {
        pcLady.talk(`I can't understand what's the deal with Ann.`, { method: "Over Chat" });
        if (Question.globalAnswers.v1AllowChrisGetAnnsNumber) {
            pcLady.talk(`Was she into that Chris guy or she just texted him to make you jealous?`, { method: "Over Chat" });
            mc.talk(`I'll get to that.`, { method: "On Chat" });
            pcLady.talk(`Come on! Give me something!`, { method: "Over Chat" });
            mc.talk(`I'll just say that at that time I thought she made him her rebound. Even though we weren't in a relationship.`, { method: "On Chat" });
            pcLady.talk(`It seems like it affected her. You said that she opened an Insta account, and from your stories, I had the feeling she was against that.`, { method: "Over Chat" });
            mc.talk(`Yup.`, { method: "On Chat" });
            pcLady.talk(`Not really something but I'll take anything that I can get!`, { method: "Over Chat" });
        } else {
            pcLady.talk(`Was she into Joe?`, { method: "Over Chat" });
            mc.talk(`It seems like that at that time.`, { method: "On Chat" });
            pcLady.talk(`Is that yes or no?`, { method: "Over Chat" });
            mc.talk(`I'll get to that.`, { method: "On Chat" });
            pcLady.talk(`So much drama for 4 people!`, { method: "Over Chat" });
            mc.talk(`I don't think she met enough guys to have had any options besides me or Joe, and I turned her down.`, { method: "On Chat" });
            pcLady.talk(`Kinda harsh, but from what you told me that sounds about right.`, { method: "Over Chat" });
        }
    }
    if (Question.globalAnswers.v3JoeGymWhoTellAboutBlackmail === false) {
        pcLady.talk(`Just shocked lol.`, { method: "Over Chat" });
        mc.talk(`Why? Because I told Vanessa to blow me?`, { method: "On Chat" });
        pcLady.talk(`That I can understand.`, { method: "Over Chat" });
        pcLady.talk(`She is a slut and you wanted to taste a piece of the pie.`, { method: "Over Chat" });
        pcLady.talk(`I'm shocked because you betrayed your best friend.`, { method: "Over Chat" });
        pcLady.talk(`Did he even forgive you since then?`, { method: "Over Chat" });
        mc.talk(`We said no spoilers.`, { method: "On Chat" });
    } else if (mc.properties.joeStatus === "enemy") {
        pcLady.talk(`Just shocked by what a real asshole you are.`, { method: "Over Chat" });
        mc.talk(`Hey!`, { method: "On Chat" });
        pcLady.talk(`I can't believe you betrayed your best friend like that.`, { method: "Over Chat" });
        pcLady.talk(`Did he even forgive you since then?`, { method: "Over Chat" });
        mc.talk(`We said no spoilers.`, { method: "On Chat" });
    }


    if (mc.properties.annStatus === "natural" && Question.globalAnswers.v3JoeGymWhoTellAboutBlackmail === undefined) {
        pcLady.talk(`I'm reading your every word!`, { method: "Over Chat" });
        mc.talk(`Prove it.`, { method: "On Chat" });
        pcLady.talk(`You just came home from the gym and Joe's birthday should be the next day! Ha!`, { method: "Over Chat" });
        mc.talk(`You did listen.`, { method: "On Chat" });
        pcLady.talk(`Told you.`, { method: "Over Chat" });
        pcLady.talk(`Ok, so keep going, you probably got home, played some of your boring games and went to sleep.`, { method: "Over Chat" });
        pcLady.talk(`Is that accurate?`, { method: "Over Chat" });
        mc.talk(`Far from that.`, { method: "On Chat" });
    } else {
        pcLady.talk(`Ok ok, so if I was following, Joe's birthday should be tomorrow right?`, { method: "Over Chat" });
        mc.talk(`Yes, but he decided to celebrate one day earlier.`, { method: "On Chat" });
        pcLady.talk(`Oh! That's where you stopped!`, { method: "Over Chat" });
        mc.talk(`Exactly.`, { method: "On Chat" });
    }
    if (mc.properties.joeStatus === "enemy") {
        pcLady.talk(`Celebrate really? After what you did to him?`, { method: "Over Chat" });
        mc.talk(`Well... Yes and no.`, { method: "On Chat" });
        pcLady.talk(`Explain!`, { method: "Over Chat" });
    }


    pcLady.talk(`So continue already!`, { method: "Over Chat" });
    mc.talk(`Fine.`, { method: "On Chat" });


    if (mc.properties.joeStatus === "enemy") {

        mc.talk(`So once I got home I got an unexpected visit.`, { method: "On Chat" });
        return jump(ClubEventWithoutJoe, "ClubEventWithoutJoe");
    }


    mc.talk(`So once Ann had left I received a text.`, { method: "On Chat" });
    return jump(ClubEventJoe, "ClubEventJoe");

};




export const homeCheckInsta = async (): Promise<any> => {
    if (mc.properties.annStatus === "hate") {
        ImageClass.setImage(images.v5.Room2_2);
        await ann.set((properties) => {
            properties.instaDescription = `Just living my life.`;
        });
    } else {
        ImageClass.setImage(images.v4.AfterBarAnnRoom31);

    }
    if (!Game.seenScenarios.includes(`homeCheckInsta`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 70;
            properties.instaFollowers = 82124;
        });
    }

    await UI.add({
        key: "v4HomeButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Go to sleep", key: "continue" }
            ]
    });
    if (UI._globalUI.v4HomeButtons === "insta") {

        await Insta.open(getInstaData());

    }
    if (UI._globalUI.v4HomeButtons === "continue") {
        if (mc.properties.annStatus === "hate") {
            return jump(AfterClub1Or5, "AfterClub1Or5");
        }
        return jump(AfterClub2To4, "AfterClub2To4");

    }
    return jump(homeCheckInsta, "homeCheckInsta");
};

export const ClubHome = async (): Promise<any> => {

    if (mc.properties.annStatus === "gf") {

        return jump(AfterClub2To4, "AfterClub2To4");
    }
    ImageClass.setImage(images.v5.Room2_2, { transition: true });
    mc.think(`That wasn't a very fun day...`);
    mc.think(`But at least it's over.`);
    mc.think(`I can check Insta before going to sleep.`);
    return jump(homeCheckInsta, "homeCheckInsta");
};


export const AfterClub1Or5 = async (): Promise<any> => {
    if (mc.properties.annLateHate) {
        if (mc.properties.joeStatus === "enemy") {

            return jump(AfterClubSMSFromVanessasPhone, "AfterClubSMSFromVanessasPhone");
        } else if (Question.globalAnswers.v1JoePresentIdea === "sextape") {

            ImageClass.setImage(images.v5.Room2_2);
            doSmsSound();
            mc.think(`Now what?`);
            await V4JoeSexTapeSMSInvite();
            mc.think(`I guess sleeping will have to wait.`);
            return jump(AfterClubSexTape, "AfterClubSexTape");
        }
    }




    return jump(AfterClubEndDay, "AfterClubEndDay");
};


export const AfterClubSMSFromVanessasPhone = async (): Promise<any> => {
    // Can be in this scenario only if mc.JoeStatus === 6 and mc.annStatus === 4 || 5
    if (mc.properties.annLateGF) {
        ImageClass.setImage(images.v4.AfterBarAnnRoom31);
    } else if (mc.properties.annLateHate) {
        ImageClass.setImage(images.v5.Room2_2);
        if (!Game.seenScenarios.includes(`AfterClubSMSFromVanessasPhone`)) {

            mc.think(`I can't believe Ann would do that.`);
            mc.think(`I would never imagine this day to be like that.`);
            mc.think(`At least it's over now, time to sleep.`);
        }

    }


    if (!Game.seenScenarios.includes(`AfterClubSMSFromVanessasPhone`)) {
        doSmsSound();
        await Phone.showMessagesUI({ name: vanessa.name, profileImage: extras.VanessaProfilePic2 }, async () => {
            Phone.setMessage({ character: vanessa.character, text: `Hey, it's not Vanessa. I was just dancing here at the bar when I saw the owner of this phone getting extremely crazy.`, options: { wait: false } });
            Phone.setMessage({ character: vanessa.character, text: `I texted you because you are the last person she called so I assumed you might be close to her.` });
            Phone.setMessage({ character: mc.character, text: `What do you mean by crazy?` });
            Phone.setMessage({ character: vanessa.character, text: `Sec.` });
            Phone.setImage({ character: vanessa.character, ...images.v4.VanessaAfterParty1 });
            Phone.setMessage({ character: mc.character, text: `Oh wow.` });
            Phone.setMessage({ character: vanessa.character, text: `You better get over here quick and take her home or something.` });
            Phone.setMessage({ character: vanessa.character, text: `I won't be here by the time you get here. So I'm going to leave the phone with the bartender.` });
            Phone.setMessage({ character: vanessa.character, text: `Bye.` });
            Phone.closeMessagesUI();
        });

    }

    mc.think(`Holy shit I think she drank too much even by her standards.`);
    if (mc.properties.annLateGF) {
        mc.think(`I can't help but feel guilty, it's kinda my fault.`);

        ImageClass.setImage(images.v4.AfterBarAnnRoom30);
        ann.talk(`I heard the phone buzzing, is everything ok?`);

        await mc.setQuestion(new Question({ text: `I better go there and help her.`, options: { think: true }, key: `v4ToldAnnGoingToHelpVanessa` })
            .option({ title: `Tell Ann you are going`, key: true })
            .option({ title: `Wait for Ann to fall asleep`, key: false }));


        if (Question.globalAnswers.v4ToldAnnGoingToHelpVanessa) {
            mc.talk(`I need to go somewhere, but I'll be right back.`);
            mc.talk(`Vanessa is in trouble.`);
            ann.talk(`Vanessa? What happened? Is she ok?`);
            mc.talk(`Yes, relax, she just had too much to drink.`);
            ann.talk(`Oh... Maybe it was a mistake to leave her alone.`);
            ann.talk(`I better get dressed and go help her.`);
            mc.talk(`No need for that, you must be tired, just go to sleep. I'll take care of it.`);
            ann.talk(`Are you sure? I don't know if she would be happy to see you.`);
            mc.talk(`I think she is too drunk to care.`);
            ann.talk(`Ok, but call me if you need my help.`);
            mc.talk(`Alright, I'll be right back.`);
        } else {
            mc.talk(`Yes.`);
            ann.talk(`Ok, hehe.`);
            ImageClass.setImage(images.v4.AfterBarAnnRoom31, { transition: true });
            mc.think(`She's asleep.`);
            mc.think(`It's time to go to the bar now.`);
            return jump(AfterClubVanessaLeftAloneWaitAbit, "AfterClubVanessaLeftAloneWaitAbit");
        }

    } else if (mc.properties.annLateHate) {
        if (Question.globalAnswers.v4StayedWithVanessaAlleyBJ === false) {
            mc.think(`Even though she tried to get me to watch her sucking some cock, I feel that I need to help her out.`);

        } else if (Question.globalAnswers.v2AgreeToSeeBJPic) {
            mc.think(`Even though Chris told me she tried to get back at me I still feel like I should help her.`);

        } else if (Question.globalAnswers.v4StayedWithVanessaAlleyBJ) {
            mc.think(`Even though she is a slut and made me watch her sucking a guy's dick I feel like I should help her out.`);

        } else {
            mc.think(`I should get there and help her.`);
        }


    }


    return jump(AfterClubVanessaLeftAloneGoFast, "AfterClubVanessaLeftAloneGoFast");
};


export const AfterClub2To4 = async (): Promise<any> => {
    ImageClass.setImage(images.v4.BarAnnAloneNoVan1, { duration: 1 });
    await mc.set((properties) => {
        properties.annBarCorruptionConv = true;
    });
    ann.talk(`There is something else I wanted to talk about...`);
    ann.talk(`But I'm afraid it's too early.`);
    mc.talk(`You can talk to me.`);
    ann.talk(`Ok...`);
    ImageClass.setImage(images.v4.BarAnnAloneNoVan4_Sad);
    ann.talk(`I have been thinking about college, who I am, what I want...so basically my life...`);
    ann.talk(`And this isn't the first time either... I've been thinking about it for a long time.`);
    mc.think(`Wow, she is getting serious now.`);
    ImageClass.setImage(images.v4.BarAnnAloneNoVan1);
    ann.talk(`I love to study and I have great plans...and I want to do great things...`);
    ann.talk(`But I also want to have fun. I want to try things... To experiment and experience what else is out there...`);
    ann.talk(`I want to get excited from stuff... I want to feel butterflies in my stomach.`);
    ann.talk(`And not just the ones I get before a big test...`);
    ann.talk(`I also want to feel what it's like to be in the spotlight... Not always... But sometimes...`);
    ann.talk(`I'm feeling I'm at a crossroad and a decision needs to be made right now.`);
    ann.talk(`And I know you must be thinking it's because of you.`);
    mc.think(`Well I am now... This is getting interesting...`);
    ann.talk(`But it is not completely because of you, but I think you might have triggered it.`);
    ann.talk(`You are a new thing in my life. I feel excited around you and everything else now seems bland by comparison.`);
    ann.talk(`I hunger for more of that feeling...`);
    ann.talk(`But it's not like I don't love my life. I do. But I might love something else even more now...`);
    await ann.setQuestion(new Question({ text: `It might be silly... But... What do you think?`, options: { think: false }, key: `v4AnnCorruptionConvWhatDoYouThink` })
        .option({ title: `I agree, you should change`, key: `youShouldChange` })
        .option({ title: `Stay the way you are`, key: "StayLikeYouAre" }));


    if (Question.globalAnswers.v4AnnCorruptionConvWhatDoYouThink === "youShouldChange") {
        await ann.set((properties) => {
            properties.corruption += 5;
        });
        mc.talk(`I agree, you should change.`);
        ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
        ann.talk(`Really?`);
        mc.talk(`Of course, if that's what you want. `);
        ann.talk(`That's the point, I don't know what I want.`);
        mc.talk(`Well why not just give it a try, and see how things go? You don't want to look back and regret never exploring what you are feeling now.`);
        ann.talk(`I guess you are right! Hehe.`);

    } else {
        await ann.set((properties) => {
            properties.corruption -= 3;
        });
        mc.talk(`Stay the way you are.`);
        ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
        ann.talk(`Really?`);
        mc.talk(`Of course, I like you the way you are, why do you need to change?`);
        ann.talk(`I guess that's true... I don't know what I was thinking.`);

    }

    doTransition(images.v4.BarAnnAloneNoVan4);






    mc.think(`Ann and I stayed at the bar.`);
    mc.think(`We spent some time talking.`);
    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v4.BarAnnKissAlone, { transition: true });
        mc.think(`Kissing...`);
    } else {

    }
    ImageClass.setImage(images.v4.BarAnnAloneNoVan4, { transition: true });
    mc.think(`And laughing.`);
    if (ann.properties.v4JoeyBirthdayDrinksNum > 2 || ann.properties.v4DrankDrug) {

        mc.think(`Ann eventually sobered up, and it was getting late.`);
    } else {

    }

    ann.talk(`It's late. We should probably leave.`);
    mc.talk(`Actually, I was thinking that maybe we can go back to my place.`);
    ann.talk(`Mmm...`);
    ann.talk(`My parents think I'll be spending the night at Vanessa's house...`);
    if (mc.properties.annLateGF) {
        ann.talk(`But before you came she told me that it's not going to happen.`);
        mc.talk(`Why?`);
        ann.talk(`She said that she is going to stay here and party all night.`);
        ann.talk(`So yeah... We can leave right now.`);
    } else {
        ann.talk(`But I think she will stay at Joe's place...`);
    }


    mc.talk(`So we are all set!`);
    ann.talk(`I don't know... It will be two nights in a row of me sleeping at your place.`);

    mc.talk(`What's wrong with that?`);
    ann.talk(`I don't know.`);
    mc.talk(`Great, so let's go.`);
    if (Question.globalAnswers.afterTODEnteredNaked) {

        ann.talk(`Are you going to sleep with clothes this time?`);
        mc.talk(`I hope not.`);
        ImageClass.setImage(images.v4.BarAnnAloneNoVan1);
        ann.talk(`Oh...`);
        mc.talk(`It was a joke.`);
        ImageClass.setImage(images.v4.BarAnnAloneNoVan4);
        ann.talk(`Oh hehe.`);
    } else {

    }
    doTransition(images.v4.AfterBarAnnMCHome1);
    ann.talk(`At one point I thought I'd be going home alone.`);
    ann.talk(`I'm glad that didn't happen. It's scary as a girl.`);
    ann.talk(`It's important for me to feel safe.`);
    ImageClass.setImage(images.v4.AfterBarAnnMCHome2);
    ann.talk(`And I really feel safe when you are with me.`);
    if (Question.globalAnswers.v1EnableNTR) {
        empty.think(`*Noises from the alley.*`);
        ImageClass.setImage(images.v4.AfterBarAnnMCHome3);
        ann.talk(`What? Who's that?`);
        mc.talk(`I have no idea.`);
        ImageClass.setImage(images.v4.AfterBarAnnMCHome4);
        await hobo.setQuestion(new Question({ text: `Come on slut. Give me a good show!`, key: `v4ToldAnnTeaseHobo` })
            .option({ title: `Tell Ann to tease him`, key: true })
            .option({ title: `Tell him to fuck off`, key: false }));


        if (Question.globalAnswers.v4ToldAnnTeaseHobo) {
            await ann.set((properties) => {
                properties.corruption += 2;
            });
            mc.talk(`Ann, didn't your mother teach you that you should always help those in need?`);
            mc.talk(`Why not put on a show for the poor guy?`);
            ann.talk(`${mc.name}? Are you crazy? I am not doing that!`);
            hobo.talk(`You didn't train her well.`);
            mc.talk(`I was joking!`);
            ann.talk(`Oh... Let's just get out of here.`);
        } else {
            mc.talk(`Don't talk to her like that, you fucking hobo.`);
            hobo.talk(`Suck it.`);
            ann.talk(`Let's go, he is not worth it.`, { method: "Whispering" });
        }

    } else {
        mc.talk(`I am happy to hear that.`);
        ann.talk(`I'm happy when you are happy, hehe.`);
        mc.talk(`Come on, let's go.`);
    }

    return jump(AfterClub2To4Home, "AfterClub2To4Home");
};

export const V4JoeSexTapeSMSInvite = async (): Promise<any> => {
    await Phone.showMessagesUI({ name: joe.name }, async () => {
        Phone.setMessage({ character: joe.character, text: `Yo ${mc.name}!`, options: { wait: false } });
        Phone.setMessage({ character: joe.character, text: `Are you still at the bar?` });
        Phone.setMessage({ character: mc.character, text: `No, I'm at home already.` });
        Phone.setMessage({ character: joe.character, text: `Cool! Can you come to Vanessa's place?` });
        Phone.setMessage({ character: mc.character, text: `I can, what is it?` });
        Phone.setMessage({ character: joe.character, text: `I'll tell you once you get here.` });
        Phone.setMessage({ character: mc.character, text: `OMW.` });
        if (Question.globalAnswers.v3JoeGymTellHimVanessaClothesHouse === false) {
            Phone.setMessage({ character: joe.character, text: `Don't you need the address?` });
            Phone.setMessage({ character: mc.character, text: `Oh yes, send it to me.` });
            Phone.setMessage({ character: joe.character, text: `Just go straight inside, the front door is open.` });
        }
        Phone.closeMessagesUI();
    });
};

export const AfterClub2To4Home24LetContinueHJToAnnEND = async (): Promise<any> => {
    ImageClass.setImage(images.v4.AfterBarAnnRoom31);
    if (mc.properties.annLateGF) {

        if (mc.properties.joeStatus !== "enemy" && Question.globalAnswers.v1JoePresentIdea === "sextape") {

            if (!Game.seenScenarios.includes(`AfterClub2To4Home24LetContinueHJToAnnEND`)) {
                doSmsSound();

                await V4JoeSexTapeSMSInvite();

            }



            if (Question.globalAnswers.v3JoeGymTellHimVanessaClothesHouse === false) {

                mc.think(`I almost got busted, he doesn't know that I've been at her place.`);
            }

            mc.think(`Ann was really tired, she fell asleep in seconds.`);
            mc.think(`I don't think she'd notice if I leave.`);

            return jump(AfterClubSexTape, "AfterClubSexTape");
        } else {

        }

    } else {

    }


    return jump(AfterClubEndDay, "AfterClubEndDay");
};


export const AfterClubEndDay = async (): Promise<any> => {

    if (mc.properties.annStatus === "gf") {
        ImageClass.setImage(images.v4.AfterBarAnnRoom31, { transition: true });
        if (!Game.seenScenarios.includes(`AfterClubEndDay`)) {
            if (Game.seenScenarios.includes(`AfterClubSexTape`) || Game.seenScenarios.includes(`AfterClubSMSFromVanessasPhone`)) {

                mc.think(`Good, Ann didn't wake up.`);
            }

        }


    } else {

        ImageClass.setImage(images.v5.Room2_2, { transition: true });
    }
    if (!Game.seenScenarios.includes(`AfterClubEndDay`)) {
        await alex.set((properties) => {
            properties.instaFollowing = 70;
            properties.instaFollowers = 82888;
        });
        mc.think(`Finally, some sleep.`);
    }

   
    await UI.add({
        key: "v4EndDayButtons",
        btns:
            [
                { image: uiImages.pc, tooltip: "Check Insta", key: "insta" },
                { image: uiImages.continue, tooltip: "Continue", key: "continue" }
            ]
    });
    if (UI._globalUI.v4EndDayButtons === "insta") {
        await Insta.open(getInstaData());
    }
    if (UI._globalUI.v4EndDayButtons === "continue") {

        if (mc.properties.annLateGF && !Game.seenScenarios.includes('AfterClubSMSFromVanessasPhone')) {
            if (mc.properties.joeStatus === "enemy") {

                return jump(AfterClubSMSFromVanessasPhone, "AfterClubSMSFromVanessasPhone");
            } else {

            }
        } else {

        }

        return jump(V5Start, "V5Start");
    }
    return jump(AfterClubEndDay, "AfterClubEndDay");
};

